// Vue Style
// A lightweight custom CSS variable plugin for Vue.js 2.0.
// https://github.com/strantr/vue-style
import VueStyle from 'vue-style'

// Hex To RGBA
// hex-to-rgba turns an old-fashioned css hex color value string into an rgba() string.
// https://github.com/misund/hex-to-rgba
import hexToRgba from 'hex-to-rgba'

const plugin = {
  install: Vue => {
    const variables = {
      'brand-primary': '#000000',
      'brand-warning': '#E6A23C',
      'input-bg': '#ffffff',
      'input-focus-bg': hexToRgba('#000000', '0.02'),
      'input-file-read-only-card-bg': hexToRgba('#000000', '0.05'),
      'input-border': '#ccc',
      'input-border-focus': '#ccc',
      'state-focus-border-bottom': '#000000',
      'state-focus-placeholder': hexToRgba('#000000', '0.3'),
      'brand-danger': '#ff0000',
      'state-danger-text': '#ff0000',
      'state-danger-bg': hexToRgba('#ff0000', '0.08'),
      'state-danger-focus-bg': hexToRgba('#ff0000', '0.16'),
      'state-danger-border': hexToRgba('#ff0000', '0.08'),
      'state-danger-addon-text': hexToRgba('#ff0000', '0.4'),
      'state-danger-placeholder': hexToRgba('#ff0000', '0.3'),
      'state-warning-text': '#E6A23C',
      'state-warning-bg': hexToRgba('#E6A23C', '0.08'),
      'state-warning-focus-bg': hexToRgba('#E6A23C', '0.16'),
      'state-warning-border': hexToRgba('#E6A23C', '0.08'),
      'state-warning-addon-text': hexToRgba('#E6A23C', '0.4'),
      'state-warning-placeholder': hexToRgba('#E6A23C', '0.3')
    }

    Vue.use(VueStyle, {
      variables: variables
    })
  }
}

export default plugin
